export default "__VITE_ASSET__DQV8URh8__"